import { IMAGES } from "../lib/site";
import PageHero from "../components/site/PageHero";
import CTASection from "../components/site/CTASection";
import { Snowflake, Sparkles, Leaf } from "lucide-react";

const SEASONS = [
  {
    icon: Snowflake,
    tag: "Winter",
    title: "Snow & Ice Clearing",
    copy: "Driveways, paths and courtyards cleared and gritted after snowfall — keeping homes and businesses safely accessible through Norfolk winters.",
    image: IMAGES.snow,
  },
  {
    icon: Sparkles,
    tag: "Festive",
    title: "Decoration Installation",
    copy: "Christmas lights, Halloween displays, seasonal exterior dressing — installed safely and taken down cleanly when the season ends.",
    image: IMAGES.christmas,
  },
  {
    icon: Leaf,
    tag: "Autumn",
    title: "Leaf Clearing",
    copy: "Full leaf collection for gardens, drives and gutters — before the wet weather turns them into a slip risk and drainage problem.",
    image: IMAGES.autumnLeaves,
  },
];

export default function Seasonal() {
  return (
    <>
      <PageHero
        overline="Through the year"
        title="Seasonal Services"
        subtitle="Snow clearing, festive decoration installation and leaf collection — tuned to Norfolk's seasons."
        image={IMAGES.autumnLeaves}
        testId="seasonal-hero"
      />

      <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 fade-up">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="overline text-neutral-500">The service</p>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              A property looked after in every weather.
            </h2>
            <p className="mt-8 text-neutral-600 text-lg leading-relaxed max-w-2xl">
              Some jobs only come once a year &mdash; but they can&rsquo;t be skipped. Book
              us seasonally, or add us to a maintenance contract and never
              think about it again.
            </p>
          </div>
        </div>
      </section>

      {/* Seasonal Cards */}
      <section
        className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 fade-up"
        data-testid="seasonal-cards"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SEASONS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="group relative overflow-hidden border border-black/10 bg-neutral-100"
                data-testid={`season-${s.tag.toLowerCase()}`}
              >
                <div className="img-hover">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-64 object-cover"
                  />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-3 text-neutral-500">
                    <Icon size={18} strokeWidth={1.5} />
                    <span className="text-[11px] tracking-[0.22em] uppercase">
                      {s.tag}
                    </span>
                  </div>
                  <h3 className="mt-4 font-serif-display text-3xl leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-neutral-600 leading-relaxed">
                    {s.copy}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
